module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/readable-stream/writable-browser.js
// module id = 569
// module chunks = 0 3 5